import { render, staticRenderFns } from "./GameSyllables.vue?vue&type=template&id=3f1f9209&scoped=true&"
import script from "./GameSyllables.vue?vue&type=script&lang=js&"
export * from "./GameSyllables.vue?vue&type=script&lang=js&"
import style0 from "./GameSyllables.vue?vue&type=style&index=0&id=3f1f9209&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f9209",
  null
  
)

export default component.exports